export enum Layout {
  TwoByTwo,
  TextLinks,
}
